// extracted by mini-css-extract-plugin
export var filterIncDec = "_fb-0";
export var leftBorder = "_fb-1";
export var rightBorder = "_fb-2";
export var stringInput = "_fb-3";